import React from "react";
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonGrid,
  IonCol,
  IonRow,
  IonImg,
  IonText,
  IonButton,
} from "@ionic/react";
import './MindMap.css';
import Logo from '../Logo';

export const Note = (props: { posts: any }) => {
  var date = "";
  var timestamp = "";

  var title = "";
  var abbrtitle = "";
  var newtitle = "";
  var helps = "";
  var important = "";
  var uid = "";

  var pdfPath = "https://explorermindsetapp.com/wp-content/uploads/pdf/";
  var linkPath = "";

  if (props.posts.title !== undefined) {
    console.log("?",props.posts.title);
    title = props.posts.title.replace(/[^\w\s]/gi, '');
    newtitle = title.replace(/\s+/g, ' ').trim()
    abbrtitle = newtitle.replace(/\s/g, "-").toLowerCase();

    console.log("title",title,newtitle,abbrtitle);
    date = props.posts.date;
    timestamp = props.posts.timestamp;
    uid = props.posts.uid;
    title = props.posts.skills.title;
    helps = props.posts.skills.mindsethelps;
    important = props.posts.skills.mostimportant;

    linkPath = pdfPath + abbrtitle + "_" + uid + "_" +  timestamp + ".pdf"; 
    console.log(linkPath);
  }else{
    console.log("props" + props.posts);
    console.log("title - log" + props.posts.title);
  }
  return (
<>


    <IonCard>
      <IonCardHeader>
      </IonCardHeader>
      <IonCardContent class="ion-text-start">
      <IonButton href={linkPath} target="_blank">Download Pdf</IonButton>
        <IonGrid className="fieldnote">
          <IonRow>
            
            <IonCol style={{marginTop:'20px'}}>
                <h2>{title}</h2>
                <strong>{date}</strong>
                
            </IonCol>
      
          </IonRow>
          <IonRow className="">
            <strong>Having an Explorer Mindset helps because</strong>
          
          </IonRow>
          <IonRow>
          <p>{helps}</p>
          </IonRow>
          <IonRow className="">
            <strong>The most important thing to me that I learned in this exploration was...</strong>
           
            </IonRow>
          <IonRow>
          <p>{important}</p>
          </IonRow>
          
        </IonGrid>
      </IonCardContent>
    </IonCard>

<IonButton onClick={() => document?.querySelector("ion-content")?.scrollToTop(500) } style={{marginLeft:'40px'}}>Top</IonButton>
</>
  );
};
